import { CircularSpinnerß } from '@otter-ai/den-components';

export function FullPageLoading() {
  return (
    <div className="flex items-center justify-center h-screen">
      <CircularSpinnerß size="sm" data-testid={null} />
    </div>
  );
}
